module.exports = __webpack_public_path__ + "static/media/ios-people.5d5e1734.svg";